import type { Collaboration } from '@/redux/collaborationsApi'
import PerformanceChart from '@/components/PerformanceChart'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface ChartSectionProps {
  campaigns: Collaboration[]
}

const ChartSection = ({ campaigns }: ChartSectionProps) => {
  return (
    <Card variant="dark" className="p-0 h-80 mb-6">
      <CardHeader className="pb-0">
        <CardTitle className="text-sm font-medium text-white">Campaign Performance</CardTitle>
      </CardHeader>
      <CardContent className="h-[calc(100%-60px)]">
        <PerformanceChart campaigns={campaigns} />
      </CardContent>
    </Card>
  )
}

export default ChartSection
